import { render, staticRenderFns } from "./UserApiKeys.vue?vue&type=template&id=28ffa9d0&scoped=true&"
import script from "./UserApiKeys.vue?vue&type=script&lang=js&"
export * from "./UserApiKeys.vue?vue&type=script&lang=js&"
import style0 from "./UserApiKeys.vue?vue&type=style&index=0&id=28ffa9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ffa9d0",
  null
  
)

export default component.exports